export default __webpack_public_path__ + "static/media/solution.34b1390f.webp";